/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Rv_1_DescInputs */

const en_pc_rv_1_desc = /** @type {(inputs: Pc_Rv_1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It opens fast and stays responsive, even on a low-power laptop with integrated graphics. No account, no upsell screen, no cloud prompt.`)
};

const zh_pc_rv_1_desc = /** @type {(inputs: Pc_Rv_1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`启动很快，操作流畅，核显低功耗笔记本上也不卡。不用账号，没有推销页面，也没有云同步弹窗。`)
};

/**
* | output |
* | --- |
* | "It opens fast and stays responsive, even on a low-power laptop with integrated graphics. No account, no upsell screen, no cloud prompt." |
*
* @param {Pc_Rv_1_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_rv_1_desc = /** @type {((inputs?: Pc_Rv_1_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Rv_1_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_rv_1_desc(inputs)
	return zh_pc_rv_1_desc(inputs)
});
export { pc_rv_1_desc as "pc.rv.1.desc" }